import { Route, Routes } from 'react-router-dom';
import { ExpertHubLayout } from 'components/templates';
import ReviewList from './components/review-list';

const Review = () => (
  <ExpertHubLayout>
    <Routes>
      <Route path="/" element={<ReviewList />} />
    </Routes>
  </ExpertHubLayout>
);

export default Review;
